export default __webpack_public_path__ + "static/media/ellips-3.9be8561e.svg";